// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/enum-bug-keys.js
// module id = 118
// module chunks = 0